import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import AppConfig from '@/app.config';
import Api from '@/Api';
import { encrypt, decrypt } from '@/helpers';

/* eslint-disable no-param-reassign */
export default createStore({
  state: {
    maps: [],
    skills: [],
    items: [],
    itemNames: [],
    monsterNames: [],
    monsters: [],
  },
  getters: {
  },
  mutations: {
    receiveItemNames(s, data) {
      s.itemNames = [...data];
    },
    receiverItems(s, data) {
      s.items = [...data];
    },
    receiveMonsterNames(s, data) {
      s.monsterNames = [...data];
    },
    receiveMonsters(s, data) {
      s.monsters = [...data];
    },
    receiveMaps(s, data) {
      s.maps = [...data];
    },
    receiveSkills(s, data) {
      s.skills = [...data];
    },
  },
  actions: {
    fetchItemNames({ commit }) {
      Api.item.items().then(({ data: response }) => {
        commit('receiveItemNames', response);
      });
    },
    fetchItems({ commit }, params) {
      return Api.item.search(params).then(({ data: response }) => {
        commit('receiverItems', response.data);
      });
    },
    fetchMonsterNames({ commit }) {
      return Api.monster.monsters().then(({ data: response }) => {
        commit('receiveMonsterNames', response);
      });
    },
    fetchMonsters({ commit }, params) {
      return Api.monster.search(params).then(({ data: response }) => {
        commit('receiveMonsters', response.data);
      });
    },
    fetchMaps({ commit }) {
      return Api.map.maps().then(({ data: response }) => {
        const maps = [];
        response.forEach((map) => {
          maps.push({
            label: map.display_name ? `${map.display_name} (${map.name})` : map.name,
            value: map.name,
          });
        });
        commit('receiveMaps', maps);
      });
    },
    fetchSkills({ commit }) {
      return Api.map.maps().then(({ data: response }) => {
        commit('receiveSkills', response);
      });
    },
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      key: AppConfig.VUEX_STORE_KEY,
      storage: AppConfig.VUEX_STORE_STORAGE,
      getState(key, storage) {
        const data = storage.getItem(key);
        if (data) {
          try {
            return decrypt(data);
          } catch (e) {
            return null;
          }
        }
        return null;
      },
      setState(key, data, storage) {
        const encrypted = encrypt(JSON.stringify(data));
        storage.setItem(key, encrypted);
      },
    }),
  ],
});
